import { render, staticRenderFns } from "./NewOriginationModal.vue?vue&type=template&id=6582c792&scoped=true&"
import script from "./NewOriginationModal.vue?vue&type=script&lang=js&"
export * from "./NewOriginationModal.vue?vue&type=script&lang=js&"
import style0 from "./NewOriginationModal.vue?vue&type=style&index=0&id=6582c792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582c792",
  null
  
)

export default component.exports